// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lzVz","col":"styles_col__13abn"};